var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCloseBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 427319453"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Close-/-Page"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.2514 3.25012C3.58661 2.91663 4.13008 2.91663 4.46529 3.25012L12 10.7508L19.5347 3.25012C19.8699 2.91663 20.4134 2.91663 20.7486 3.25012C21.0838 3.58361 21.0838 4.1243 20.7486 4.45779L13.172 11.9998L20.7486 19.5422C21.0838 19.8757 21.0838 20.4164 20.7486 20.7499C20.4134 21.0834 19.8699 21.0834 19.5347 20.7499L12 13.2483L4.46529 20.7499C4.15587 21.0577 3.66899 21.0814 3.33227 20.8209L3.2514 20.7499C2.9162 20.4164 2.9162 19.8757 3.2514 19.5422L10.828 11.9998L3.2514 4.45779C2.9162 4.1243 2.9162 3.58361 3.2514 3.25012Z",
    fill: "#343434"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseBlack);
export default __webpack_public_path__ + "static/media/icon-close-black.e8ed89fc2a741c16568e896612b22283.svg";
export { ForwardRef as ReactComponent };